import { ChevronDown, MoreVertical } from "lucide-react";
import type { ReactNode } from "react";
import { cn } from "@repo/utils";
import type { IconProps } from "./dropdown.types.js";

type Props = {
  trigger?: ReactNode;
  icon?: IconProps;
  className?: string;
};

const ICON_MAP = {
  dots: <MoreVertical className="h-5 w-5" />,
  chevron: <ChevronDown className="h-5 w-5" />,
} as const;

const DropdownTriggerIcon = ({ trigger, icon = "dots", className }: Props) => {
  if (trigger && icon === "custom") return trigger;
  if (icon === "custom") return null;

  const iconElement = trigger || ICON_MAP[icon];

  return (
    <div
      className={cn(
        "inline-flex items-center justify-center rounded-md bg-gray-50 p-2 transition-colors hover:bg-gray-200 focus:ring-2 focus:ring-blue-500 focus:outline-none",
        className
      )}
    >
      {iconElement}
    </div>
  );
};

export default DropdownTriggerIcon;
